import React, { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Button, SearchInput } from '@paypalcorp/pp-react';
import styles from './searchBar.less';
import MediaQuery from 'react-responsive';
import * as analytics from '../../lib/analytics';

const SearchBar = (
  {
    isMobile,
    authState,
    contentCountry,
    i18n,
    searchSubmitUrl,
    supportedProduct,
  },
  ...props
) => {
  const [keywords, setKeywords] = useState('');
  const [clearKeywords, setClearKeywords] = useState(false);

  const onKeywordChanged = (e) => setKeywords(e.target.value);

  function recordSearchEvent(keyword) {
    analytics.instance.recordEvent(analytics.events.DW_GIVING_SEARCH_PRESSED, {
      e: 'cl',
      item_name: 'dw_giving',
      event_source: isMobile ? 'mobile' : 'web',
      account_type: authState === 'ANONYMOUS' ? 'guest' : 'member',
      acct_cntry: contentCountry,
      keyword,
    });
  }

  const onFormSubmitted = () => {
    recordSearchEvent(keywords);

    let url;
    if (!isEmpty(searchSubmitUrl)) {
      url = new URL(window.location.origin);
      url.pathname = searchSubmitUrl;
    } else {
      url = new URL(window.location.href);
    }
    const search = new URLSearchParams();

    const urlParams = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );

    search.append('keywords', keywords || '');

    search.append('type', supportedProduct);

    search.append('page', '1');

    search.append('pageSize', urlParams.pageSize ? urlParams.pageSize : 24);

    search.append('sortBy', urlParams.sortBy ? urlParams.sortBy : 'bestmatch');

    url.search = search;
    window.location = url;
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onFormSubmitted();
    }
  };

  const handleClear = () => {
    if (keywords.length > 0) {
      setKeywords('');
      setClearKeywords(true);
    }
  };

  useEffect(() => {
    if (clearKeywords) {
      onFormSubmitted();
    }
  }, [clearKeywords]);

  let searchInputLabel = i18n('label.search-common-placeholder');
  if (supportedProduct === 'charities') {
    searchInputLabel = i18n('label.search-placeholder');
  }

  if (supportedProduct === 'fundraisers') {
    searchInputLabel = i18n('label.search-fundraiser-placeholder');
  }

  return (
    <div>
      <div className={styles.searchContainer}>
        <div className={styles.searchInputContainer}>
          <SearchInput
            id={'inputSearchBar'}
            label={searchInputLabel}
            name='keywords'
            value={keywords}
            onClear={handleClear}
            onChange={onKeywordChanged}
            onKeyUp={handleKeyPress}
          />
        </div>
        <MediaQuery minWidth={752}>
          <div className={styles.searchButtonContainer}>
            <Button id={'searchButton'} onClick={onFormSubmitted} primary>
              {i18n('label.search-button')}
            </Button>
          </div>
        </MediaQuery>
      </div>
    </div>
  );
};

export default SearchBar;
